import React from 'react';
import { toast } from 'sonner';
import Toast from './Toast';
const defaultOptions = {
    position: 'top-center',
};
export const showInfoToast = (message, options) => {
    toast.custom((t) => React.createElement(Toast, { type: "info", message: message, toastId: t }), { ...defaultOptions, ...options });
};
export const showSuccessToast = (message, options) => {
    toast.custom((t) => (React.createElement(Toast, { type: "success", message: message, toastId: t })), { ...defaultOptions, ...options });
};
export const showWarningToast = (message, options) => {
    toast.custom((t) => (React.createElement(Toast, { type: "warning", message: message, toastId: t })), { ...defaultOptions, ...options });
};
export const showErrorToast = (message, options) => {
    toast.custom((t) => (React.createElement(Toast, { type: "error", message: message, toastId: t })), { ...defaultOptions, ...options });
};
